import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './AddOnModal.module.scss';
import useClickAwayListener from '../../hooks/useClickAwayLitsner';
import { clickTracker, getSourceValue, handleRedirection } from '../../lib/common';

const AddOnModal = ({ setAddOnsData, addOnsData }) => {
  const addOnModalRef = useRef(null);
  const source = getSourceValue();
  const handleAddOnModal = () => {
    document.body.style.overflow = 'unset';
    setAddOnsData([]);
  };
  useClickAwayListener(addOnModalRef, () => {
    handleAddOnModal();
  });
  return (
    <section
      className={`cs_modal ${styles.AddOneModal} `}
      style={{ width: 'min(100%, 1098px)', right: 0, margin: '0 auto' }}
    >
      <div ref={addOnModalRef} className={`cs_modal_content cs_modal_animation cs_modal_up ${styles.Content} `}>
        <div className="cs_modal_body pb-20">
          <div className={`cs_modal_header ${styles.Header} p-20`}>
            <div className={`cs_modal_head_center ${styles.Center} font16 fw600 color111`}>Add Ons</div>
            <div className={`cs_modal_head_right ${styles.Right}`}>
              <div
                className="modal_close csicon"
                onClick={() => handleAddOnModal()}
                aria-label="Close Modal"
                type="button"
                tabIndex={0}
                role="button"
                onKeyDown={() => {}}
              />
            </div>
          </div>
          <ul className={`${styles.List} pl-20 pr-20`}>
            {addOnsData?.map((each, idx) => (
              <li
                role="presentation"
                onClick={async () => {
                  await clickTracker(`FAQ_view_${each?.trackerId}`, 'addon_FAQ');
                  handleAddOnModal();
                  handleRedirection(source, each?.redirectionUrl || '');
                }}
                className={`${styles.Item} mt-15`}
                key={idx}
              >
                <div className={`${styles.ImageBox}`}>
                  <img alt={`addOn_img_${each?.name}`} className={`${styles.Image}`} src={each?.image} />
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default AddOnModal;
AddOnModal.propTypes = {
  setAddOnsData: PropTypes.func,
  addOnsData: PropTypes.array,
};
